import {Injectable} from "@angular/core";

@Injectable()
export class ConferenceMetaPixelService {
  private customerPixelId: string | null = null;

  initCustomerPixel(pixelId: string): void {
    if (this.customerPixelId === pixelId) return;
    this.customerPixelId = pixelId;
    if (!this.customerPixelId) return;

    this.loadPixelScript();
    (<any>window).fbq.disablePushState = true;
    (<any>window).fbq('init', pixelId);
    console.log('initCustomerPixel called:', pixelId);
  }

  trackConferenceEvent(eventName: string, params?: object): void {
    if (!this.customerPixelId || !(<any>window).fbq) return;
    (<any>window).fbq('trackSingle', this.customerPixelId, eventName, params);
    console.log('trackConferenceEvent called:', eventName, '| pixelId:', this.customerPixelId);
  }

  clearCustomerPixel(): void {
    this.customerPixelId = null;
  }

  private loadPixelScript(): void {
    if ((<any>window).fbq) return;

    (function(f: any, b: Document, e: string, v: string) {
      const n: any = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode!.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }
}
